import { CreateCustomerRequestBody, RegistrationResponseBody } from '@boltenergy-be/shared'
import { NextApiResponseBody } from 'types/bolt-api/request'

export const createCustomer = async (body: CreateCustomerRequestBody): Promise<NextApiResponseBody<RegistrationResponseBody>> => {
  try {
    const res = await fetch(`/api/registrations/customers`, {
      method: 'POST',
      body: JSON.stringify(body)
    })

    return (await res.json()) as NextApiResponseBody<RegistrationResponseBody>
  } catch (error) {
    return {
      success: false,
      message: error?.message || 'createCustomer request failed'
    }
  }
}
